import React, { useState, useEffect, useRef } from 'react';
// import './order-list.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dialog } from 'primereact/dialog';
import moment from 'jalali-moment';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader'
import { GetpaymentImg, GetReport } from '../../utils/api';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import 'primeicons/primeicons.css';

import { Column } from 'primereact/column';
import ClipBoard from '../../assets/icons/clipboard2.svg'

//icon
import UploadIcon from '../../assets/icons/ticket/upload.svg';
import useToastNotification from '../../hooks/useToastNotification';

function Orders() {
    const toast = useRef(null);
    const datePickerRef = useRef(null);
    const datePickerRef1 = useRef(null);
    const mobileDatePickerRef1 = useRef(null);
    const mobileDatePickerRef = useRef(null);

    const [visibleDetailDialog, setVisibleDetailDialog] = useState(false); // Dialog visibility state
    const [fromDate, setFromDate] = useState(null);
    const [base64Img, setBase64Img] = useState('');
    // const [toDate, setToDate] = useState(null);
    const [status, setStatus] = useState('');
    const [orderID, setOrderID] = useState('');
    const [searchLoader, setSearchLoader] = useState(false);
    const [customerData, setCustomerData] = useState();
    const [reportData, setReportData] = useState('');
    const [factorListMap, setFactorListMap] = useState([]);
    const [loading, setLoading] = useState(false);
    const [BranchName, setBranchName] = useState('');
    const [toDate, setToDate] = useState(null);
    const items = [{ label: 'سفارشات من' }];
    const [file, setFile] = useState(null);
    const { showError, showSuccess } = useToastNotification();



    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };



    const [date, setDates] = useState([
        new DateObject().setMonth(new Date().getMonth() - 5),
        new DateObject(),
    ])

    // isSettingTo uses only when the 'to date' datepicker opens to detect user's setting the 'to date' and prevent setting the 'from date' again.
    const [isSettingTo, setIsSettingTo] = useState(false);
    const [isSettingfrom, setIsSettingfrom] = useState(false);

    const onDateRangeChanged = (location, e) => {
        if (isSettingfrom) {
            handleFocus1()
            mobileHandleFocus1()
            closefromCalendar()
            mobileClosefromCalendar()
        } else if (!isSettingfrom && !isSettingTo) {
            handleFocus()
            mobileHandleFocus()
            closeToCalendar()
            mobileCloseToCalendar()
        }
        if (isSettingTo) {
            if (e[0].format().toString() == date[0].format().toString()) {
                setDates(e);
            } else {
                setDates((old) => {
                    old[1] = e[0];
                    return old;
                });
                setIsSettingTo(false);
            }


        }
        else {
            setDates(e);
        }
    };
    const onCalenderOpened = (e) => {

        if (e === 'to') {
            setIsSettingTo(true);
            setIsSettingfrom(false)
        }
        if (e === 'from') {
            setIsSettingfrom(true)
            setIsSettingTo(false);

        }

    };

    const formatDateObject = (dateObject) => {
        if (!dateObject) return "";
        const startDate = dateObject.split(' ~ ')[0];
        return startDate;
    };
    const formatDateObjectTo = (dateObject) => {
        if (!dateObject) return "";
        const endDate = dateObject.split(' ~ ')[1];
        return endDate;
    };
    const handleFocus = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };
    const closefromCalendar = () => {
        if (datePickerRef.current) {
            datePickerRef.current.closeCalendar();
        }
    };
    const closeToCalendar = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.closeCalendar();
        }
    };
    const mobileClosefromCalendar = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.closeCalendar();
        }
    };
    const mobileCloseToCalendar = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.closeCalendar();
        }
    };
    const handleFocus1 = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.openCalendar();
        }
    };
    const mobileHandleFocus = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.openCalendar();
        }
    };
    const mobileHandleFocus1 = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.openCalendar();
        }
    };
    // When the date range changes, update fromDate and toDate
    useEffect(() => {
        if (date && date.length === 2) {

            setFromDate(date[0]);
            setToDate(date[1]);
        }
    }, [date]);




    const ordersData = async (pay) => {
        try {
            setSearchLoader(true)
            let res = await GetReport(pay);
            if (res.status === 200) {
                setReportData(res.data);
                setSearchLoader(false)
            }
        } catch (error) {
            setSearchLoader(true)
            // Handle the error appropriately, e.g., show an error message to the user, log it, etc.
        } finally {
        }
    };


    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        setCustomerData(JSON.parse(customerDatares));
        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 6);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {
            fromDate: convertDateToPersian(fromDateNew),
            toDate: convertDateToPersian(new Date()),
            userId: JSON.parse(customerDatares).si,

        };

        ordersData(pay);
    }, []);

    useEffect(() => {
    }, [fromDate, toDate])




    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };




    useEffect(() => {
    }, [factorListMap])


    const searchOrder = async () => {
        let payload = {
            fromDate: convertPersianDigitsToEnglish(date[0].format()),
            toDate: convertPersianDigitsToEnglish(date[1].format()),
            userId: JSON.parse(localStorage.getItem('userInfo')).si,

        };
        ordersData(payload);
    };



    function convertPersianDigitsToEnglish(text) {
        // Define a mapping of Persian digits to English digits
        const persianToEnglishDigits = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        // Use a regular expression to find Persian digits and replace them
        return text.replace(/[۰-۹]/g, function (match) {
            return persianToEnglishDigits[match];
        });
    }


    const handleDialogClose = () => {
        setVisibleDetailDialog(false);

    };





    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result;
                const extension = file.name.split('.').pop().toLowerCase();

                resolve({
                    base64: base64String,
                    extension: extension,
                });
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };

    const convertBase64ToImg = (base64) => {

    }
    const getPdf = async (data) => {
        console.log(data)
        try {
            let payload = {
                userId: (JSON.parse(window.localStorage.getItem('userInfo')).si).toString(),
                factorId: data.IdRef
            };

            let res = await GetpaymentImg(payload);
            console.log(res)
            if (res.status == 200) {
                setBase64Img(res.data)
                setVisibleDetailDialog(true)
            }

        } catch (error) {
            console.error('Error while generating image', error);
        }
    };

    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                {rowData.Act ==  'B' && (
                    <img
                        src={ClipBoard}
                        alt="edit"
                        className="cursor-pointer mx-1"
                        onClick={() => getPdf(rowData)}
                        style={{ width: '24px', height: '24px' }}
                    />
                )}


            </div>
        );
    };

    
    const setStatusfunc = (rowData) => {        
        return (
            <div className=''>{
                rowData.Act == 'A' ? 'تایید سفارش' : rowData.Act == 'B' ? 'آپلود فیش پرداخت' : rowData.Act == 'C' ? 'باطل شده' : rowData.Act == 'D' ? 'مرجوعی مبلغ توسط مدیریت' : rowData.Act == 'E' ? 'ثبت توسط مدیریت' : 'در حال بررسی'
             }

            </div>
        );
    };
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    return (
        <div>
            <div className='profile-card'>
                <h6 className='page-title mb-4 mt-3'>گزارشات مالی</h6>
                <Toast ref={toast} />
                <div className='contain'>
                    <div className='order-body'>
                        <div className='ticket-box  order-filter'>
                            <div className='web-filter d-flex align-items-center justify-content-between w-100'>
                                <Form className='flex-1 w-100'>

                                    <div className='row'>
                                        <Form.Group className=" col-md-4 col-lg-3 col-sm-12">
                                            <Form.Label>از تاریخ</Form.Label>
                                            <DatePicker
                                                range
                                                numberOfMonths={2}
                                                showOtherDays
                                                value={date}
                                                onChange={(e) => onDateRangeChanged('from', e)}
                                                onOpen={() => onCalenderOpened('from')}
                                                calendar={persian}
                                                weekDays={weekDays}
                                                locale={persian_fa}
                                                render={(value) => {
                                                    const fromDateFormatted = formatDateObject(value);
                                                    return <input className='form-control f-1m' readOnly onFocus={handleFocus} value={fromDateFormatted} />;
                                                }}
                                                ref={datePickerRef}

                                            />
                                        </Form.Group>
                                        <Form.Group className=" col-md-4 col-lg-3 col-sm-12">
                                            <Form.Label>تا تاریخ</Form.Label>
                                            <DatePicker
                                                range
                                                numberOfMonths={2}
                                                showOtherDays
                                                value={date}
                                                onChange={(e) => onDateRangeChanged('to', e)}
                                                onOpen={() => onCalenderOpened('to')}
                                                calendar={persian}
                                                weekDays={weekDays}
                                                locale={persian_fa}
                                                render={(value) => {
                                                    const fromDateFormatted = formatDateObjectTo(value);
                                                    return <input className='form-control f-1m' readOnly onFocus={handleFocus1} value={fromDateFormatted} />;
                                                }}
                                                ref={datePickerRef1}
                                            />
                                            {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                                        </Form.Group>
                                        <div className=" col-md-4 col-lg-3 col-sm-12"></div>
                                        <div className=" col-md-4 col-lg-3 col-sm-12">
                                            <button disabled={searchLoader} className='btn btn-primary  px-5 d-flex align-items-center justify-content-center gap-2 mt-3' style={{ float: 'left' }} onClick={searchOrder}> {searchLoader && <Loader />}جستجو</button>
                                        </div>
                                    </div>



                                </Form>
                            </div>
                            <div className='mobile-filter report-page'>
                                <Accordion >
                                    <AccordionTab
                                        header={
                                            <span className="d-flex align-items-center justify-content-between py-4 gap-2 w-full">
                                                <span style={{ fontSize: '14px', fontWeight: '700' }}>فیلترها</span>
                                            </span>
                                        }
                                    >
                                        <Form className='row '>
                                            <Form.Group className=" col-md-4 col-lg-4 col-sm-12">
                                                <Form.Label>از تاریخ</Form.Label>
                                                <DatePicker
                                                    range
                                                    numberOfMonths={2}
                                                    showOtherDays
                                                    value={date}
                                                    onChange={(e) => onDateRangeChanged('from', e)}
                                                    onOpen={() => onCalenderOpened('from')}
                                                    calendar={persian}
                                                    weekDays={weekDays}
                                                    locale={persian_fa}
                                                    render={(value) => {
                                                        const fromDateFormatted = formatDateObject(value);
                                                        return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus} value={fromDateFormatted} />;
                                                    }}
                                                    ref={mobileDatePickerRef}
                                                />
                                            </Form.Group>
                                            <Form.Group className=" col-md-4 col-lg-4 col-sm-12 mt-2">
                                                <Form.Label>تا تاریخ</Form.Label>
                                                <DatePicker
                                                    range
                                                    numberOfMonths={2}
                                                    showOtherDays
                                                    value={date}
                                                    onChange={(e) => onDateRangeChanged('to', e)}
                                                    onOpen={() => onCalenderOpened('to')}
                                                    calendar={persian}
                                                    weekDays={weekDays}
                                                    locale={persian_fa}
                                                    render={(value) => {
                                                        const fromDateFormatted = formatDateObjectTo(value);
                                                        return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus1} value={fromDateFormatted} />;
                                                    }}
                                                    ref={mobileDatePickerRef1}
                                                />
                                            </Form.Group>


                                            <button disabled={searchLoader} style={{ height: '40px', width: '90%' }} className='btn btn-primary mx-auto  my-3 px-5 d-flex align-items-center justify-content-center gap-2' onClick={searchOrder}> {searchLoader && <Loader />}جستجو</button>
                                        </Form>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                        </div>


                        <div className='mt-5'>
                            <DataTable
                                value={reportData}
                                size="small"
                                lazy
                                tableStyle={{ minWidth: '50rem' }}
                            >
                                <Column header="نوع فعالیت" style={{ width: '10%' }} body={setStatusfunc}></Column>
                                <Column field="Bes" header="مبلغ بدهی" style={{ width: '10%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                                <Column field="Bed" header="مبلغ پرداختی" style={{ width: '10%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                                <Column field="DDate" header="تاریخ" style={{ width: '10%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                                <Column field="Tp" header="توضیحات" style={{ width: '15%' }} body={loading ? skeletonBodyTemplate : null}></Column>
                                <Column header="رسید پرداخت" body={actionTemplate} style={{ width: '15%' }}></Column>

                            </DataTable>

                        </div>


                    </div>
                </div>

                <Dialog
                    draggable={false}
                    dismissableMask
                    visible={visibleDetailDialog}
                    style={{ width: '35vw' }}
                    breakpoints={{ '1800px': '35vw', '1600px': '35vw', '1400px': '50vw', '1100px': '60vw', '900px': '80vw', '600px': '400vw', '500px': '95vw' }}
                    onHide={handleDialogClose}
                    className="custom-dialog  dialog-profile"
                    header="رسید پرداخت"
                >
                    <hr className='web' />
                    <div className='d-flex align-items-center justify-content-center'>
                        <img src={base64Img} alt="" />
                    </div>

                </Dialog>


            </div>


        </div>
    );
}

export default Orders;
